export interface ListProps {
	id: string;
	key?: number;
	sort?: number;
	st_fileurl: string;
	st_text_title: number;
	st_thumbnail?: string;
	st_type: number;
	type: string;
	transition?: string;
	st_tail_vedio?: any;
}
export interface ObjProps {
	type: string;
	time: number;
	width: number;
	height: number;
	index: number;
	dom: any;
	startImg?: any;
	endImg?: any;
	startTime?: number;
	endTime?: number;
	transition: string;
}
export function calculateSize(domW, domH, canvasWidth, canvasHeight) {
	let x = 0, y = 0, w = canvasWidth, h = canvasHeight
	// console.log('w=>',canvasWidth,' h==>',canvasHeight,' domH=>',domH,' domW=>',domW)

	if(domH > domW && domW > w) {

		// console.log('=>1')
		w = domW * canvasHeight / domH
		x = (canvasWidth - w)/2

	} else if(((domW < domH && domW < canvasWidth) || (domW > domH  && domW > canvasWidth)) && domH > canvasHeight ){

		// console.log('=>2')
		const testW = canvasHeight * domW / domH
		const testH = canvasWidth * domH / domW
		if(testW > canvasWidth) {
			h = testH
			y = (canvasHeight - h) / 2
		} else if (testH > canvasHeight) {
			w = testW
			x = (canvasWidth - w) / 2
		} else {
			// console.log('=> 2 else!!!')
		}
	} else if(domH === domW && domH < canvasHeight && domH < canvasWidth) {

		// console.log('=>3')
		w = domW
		h = domH
		x = (canvasWidth - w) / 2
		y = (canvasHeight - h) / 2
	} else if (domW < domH && domW < canvasWidth && domH < canvasHeight){

		// console.log('=>4')
		w = domW
		h = domH
		x = (canvasWidth - w ) / 2
		y = (canvasHeight - h) / 2
	} else if(domW < domH && domH > canvasHeight && domW > canvasWidth) {

		// console.log('=>6')
		h = canvasWidth * domH / domW
		y = (canvasHeight - domH) / 2
	} else {

		// console.log('=>7')
		h = domH * canvasWidth / domW
		y = (canvasHeight - h) / 2
	}
	return {x: Math.floor(x), y: Math.floor(y), w: Math.floor(w), h: Math.floor(h)}
}
export function convertImageToBase64(url, canvasW, canvasH) {
	return new Promise((resolve) => {
		const canvas = document.createElement('canvas')
		const ctx = canvas.getContext('2d')
		const imgObj = new Image()
		imgObj.setAttribute('crossOrigin', 'anonymous')
		imgObj.src = url
		imgObj.onload = function () {
			canvas.width = canvasW
			canvas.height = canvasH
			const data = calculateSize(this.width, this.height, canvasW, canvasH)
			ctx.drawImage(this, data.x, data.y, data.w, data.h)
			const toDataURL = canvas.toDataURL('image/jpeg') // toDataUrl可以接收2个参数，参数一：图片类型，参数二： 图片质量0-1（不传默认为0.92）
			const newImg = new Image()
			newImg.src = toDataURL
			newImg.onload= function() {
				resolve(newImg)
			}
		}
	})

}
export const handleImage = (url: string, idx: number, type: string, trans: string, cw: number, ch: number) => {
	return new Promise((resolve) => {
		const img = new Image()
		img.src = url
		img.onload = () => {
			convertImageToBase64(url, cw, ch).then(newImage => {
				resolve({
					index: idx,
					dom: newImage,
					type,
					time: 2,
					width: img.width,
					height: img.height,
					transition: trans
				})
			})
		}
	})
}
export const screenShot = (video, time, width, height, cw: number, ch: number) => {
	return new Promise((resolve) => {
		const canvas = document.createElement('canvas')
		canvas['width'] =  cw
		canvas['height'] =  ch
		video['currentTime'] = time
		let flag = true
		video.addEventListener('canplay', () => {
			if(flag) {
				flag = false
				const data = calculateSize(video.videoWidth, video.videoHeight, cw, ch)
				canvas.getContext('2d').drawImage(video, data.x, data.y, data.w, data.h)
				const dataURLTo = canvas.toDataURL('image/jpeg')
				const img = new Image()
				img.crossOrigin = 'anonymous'
				img.src = dataURLTo
				img.onload = () => {
					console.log('screenShot-resolve')
					resolve(img)
				}
			}
		})
	})
}
export const handleVideo = (url: string, idx: number, type: string, trans: string, cw: number, ch: number) => {
	return new Promise((resolve) => {
		const video = document.createElement('video')
		video['src'] = url
		video.crossOrigin = 'anonymous'
		let flag = true
		video.addEventListener('canplay', () =>{
			if(flag) {
				flag = false
				const width = video.videoWidth, height = video.videoHeight, duration = Math.round(video.duration)
				Promise.all([screenShot(video, 1, width, height, cw, ch), screenShot(video, duration - 1, width, height, cw, ch)]).then(res => {
					resolve({
						type,
						time: duration,
						width,
						height,
						index: idx,
						dom: video,
						startImg: res[0],
						endImg: res[1],
						startTime: 1,
						endTime: duration-1,
						transition: trans
					})
				})
			}
		})
	})
}
export const handleTrasitionData = (
	list: ListProps[],
	canvasW: number,
	canvasH: number,
	transitionType?: string,
	st_tail_vedio?: any
) => {
	return new Promise((resolve) => {

		const promistList = []
		list.forEach((item, index) => {
			if(item.type === '图片') {
				promistList.push(handleImage(item.st_fileurl, index, item.type, transitionType ? transitionType :'none', canvasW, canvasH))
			} else if(item.type === '视频') {
				promistList.push(handleVideo(item.st_fileurl, index, item.type, transitionType ? transitionType :'none', canvasW, canvasH))
			}
		})
		// console.log('任务：图片处理base64,视频生成首尾图片', promistList)
		Promise.all(promistList).then(res => {
			// console.log('结果：图片处理base64,视频生成首尾图片',res)
			const arr = [] // 转场
			let duration = 0
			for(let i = 0; i < res.length - 1; i++) {
				duration += Math.round(res[i].time)
				if(res[i].transition !== 'none') duration += 1
				if(res[i].type === '图片' && res[i+1].type === '图片') {
					arr.push({
						from: res[i].dom,
						to: res[i+1].dom,
						fromW: res[i].width,
						fromH: res[i].height,
						toW: res[i+1].width,
						toH: res[i+1].height,
						transition: res[i].transition,
						time: 1,
						type: '转场'
					})
				} else if(res[i].type === '图片' && res[i+1].type === '视频') {
					arr.push({
						from: res[i].dom,
						to: res[i+1].startImg,
						fromW: res[i].width,
						fromH: res[i].height,
						toW: res[i+1].width,
						toH: res[i+1].height,
						transition: res[i].transition,
						time: 1,
						type: '转场'
					})
				} else if(res[i].type === '视频' && res[i+1].type === '视频') {
					arr.push({
						from: res[i].endImg,
						to: res[i+1].startImg,
						fromW: res[i].width,
						fromH: res[i].height,
						toW: res[i+1].width,
						toH: res[i+1].height,
						transition: res[i].transition,
						time: 1,
						type: '转场'
					})
				} else if(res[i].type === '视频' && res[i+1].type === '图片') {
					arr.push({
						from: res[i].endImg,
						to: res[i+1].dom,
						fromW: res[i].width,
						fromH: res[i].height,
						toW: res[i+1].width,
						toH: res[i+1].height,
						transition: res[i].transition,
						time: 1,
						type: '转场'
					})
				}
			}
			duration = duration + Math.round(res[res.length - 1].time) // i < res.length - 1
			if(st_tail_vedio) {duration += 2}
			const len = arr.length //转场比素材少一个
			const result = []

			for(let i = 0; i < len; i++) {
				result.push(res[i])
				result.push(arr[i])
			}
			result.push(...res.slice(len, res.length))
			console.log('结果：生成播放及转场数据结构 and duration', duration, result)
			resolve({
				result,
				duration
			})
		})
	})

}

export const getVideoDuration= (url) => {
	return new Promise((resolve) => {
		const video = document.createElement('video')
		video['src'] = url
		video.crossOrigin = 'anonymous'
		let flag = true
		video.addEventListener('canplay', () =>{
			if(flag) {
				flag = false
				resolve(Math.round(video.duration))
			}
		})
	})
}
export const calculateDuration = (dataList, st_glsl) => {
	return new Promise((resolve) => {
		let duration = st_glsl ? dataList.length - 1 : 0
		let videoDuration = 0
		const promiseList = []
		dataList.forEach((item ) => {
			if(item.type === '图片') {
				duration= duration + 2
			} else if(item.type === '视频')  {
				promiseList.push(getVideoDuration(item.st_fileurl))
			}
		})
		Promise.all(promiseList).then(res => {
			videoDuration = res.length > 0 ? eval(res.join('+')) : 0
			console.log('calculateDuration',duration+videoDuration,res)
			resolve(duration + videoDuration)
		})
	})
}

// 获取高度与canvas相同等比例的图片 缩放后的图片转为base64
export const handleZoomImageBase64 = (url,canvasHeight) => {
	return new Promise((resolve) => {
		const canvas = document.createElement('canvas')
		const ctx = canvas.getContext('2d')
		const img = new Image()
		img.setAttribute('crossOrigin', 'anonymous')
		img.src = url
		img.onload = () => {
			const imageWidth = img.width,
				imageHeight = img.height,
				playHeight = canvasHeight,
				playWidth = (playHeight/imageHeight*imageWidth).toFixed(0)

			canvas.width = playWidth
			canvas.height = playHeight
			ctx.drawImage(img, 0, 0, playWidth, playHeight)
			const toDataURL = canvas.toDataURL('image/jpeg') // toDataUrl可以接收2个参数，参数一：图片类型，参数二： 图片质量0-1（不传默认为0.92）
			const newImg = new Image()
			newImg.src = toDataURL
			newImg.onload= function() {
				resolve({
					imgDom: newImg,
					playHeight,
					playWidth,
					imageWidth,
					imageHeight
				})
			}
		}
	})
}


